import { render } from "./VideoDynamicModal.vue?vue&type=template&id=5ec3cba0&scoped=true"
import script from "./VideoDynamicModal.vue?vue&type=script&lang=js"
export * from "./VideoDynamicModal.vue?vue&type=script&lang=js"

import "./VideoDynamicModal.vue?vue&type=style&index=0&id=5ec3cba0&scoped=true&lang=css"

import exportComponent from "C:\\AgentIFAS\\_work\\33\\s\\Nezivotko.Web2\\CreditWorthiness\\real-world-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec3cba0"]])

export default __exports__